import React, { useEffect, useState } from "react";

const AutocompleteInput = React.forwardRef(
    ({ name, label, value, onChange, error, fetchSuggestions }, ref) => {
        const [suggestions, setSuggestions] = useState([]);
        const [showSuggestions, setShowSuggestions] = useState(false);
        const [inputText, setInputText] = useState(value?.title || "");
        const [wasSelected, setWasSelected] = useState(false);

        useEffect(() => {
            setInputText(value?.title || "");
        }, [value]);

        useEffect(() => {
            if (wasSelected) {
                setWasSelected(false);
                return;
            }

            const fetch = async () => {
                if (fetchSuggestions && inputText.length > 2) {
                    try {
                        const results = await fetchSuggestions(inputText);
                        setSuggestions(results || []);
                        setShowSuggestions(true);
                    } catch (err) {
                        console.error("Autocomplete error:", err);
                        setSuggestions([]);
                        setShowSuggestions(false);
                    }
                } else {
                    setSuggestions([]);
                    setShowSuggestions(false);
                }
            };

            const debounce = setTimeout(fetch, 300);
            return () => clearTimeout(debounce);
        }, [inputText]);

        const handleInputChange = (e) => {
            const text = e.target.value;
            setInputText(text);
            setWasSelected(false);
            onChange({ target: { name, value: text } }); // pass raw text
        };

        const handleSuggestionClick = (suggestion) => {
            setInputText(suggestion.title);
            setWasSelected(true);
            setShowSuggestions(false);
            onChange({ target: { name, value: suggestion } });
        };

        const filteredSuggestions = suggestions.filter(
            (s) => !value || s.placeId !== value.placeId
        );

        return (
            <div className="autocompleteInput" style={{ position: "relative" }}>
                <div className="autocompleteInput__container">
                    <input
                        id={name}
                        name={name}
                        type="text"
                        className="autocompleteInput__field"
                        autoComplete="off"
                        value={inputText}
                        onChange={handleInputChange}
                        ref={ref}
                    />
                    <label htmlFor={name} className="autocompleteInput__label">
                        {label}
                    </label>
                </div>

                {showSuggestions && (!value || inputText.toLowerCase() !== value?.title?.toLowerCase()) && (
                    <ul className="autocompleteInput__suggestions">
                        {filteredSuggestions.length > 0 ? (
                            filteredSuggestions.map((sugg, index) => (
                                <li
                                    key={sugg.placeId || index}
                                    className="autocompleteInput__suggestion"
                                    onMouseDown={() => handleSuggestionClick(sugg)}
                                >
                                    {sugg.title}
                                </li>
                            ))
                        ) : (
                            inputText.length > 3 && (
                                <li className="autocompleteInput__suggestion">Adresas nerastas</li>
                            )
                        )}
                    </ul>
                )}

                {error && (
                    <div className="autocompleteInput__error">{error.message}</div>
                )}
            </div>
        );
    }
);

AutocompleteInput.displayName = "AutocompleteInput";
export default AutocompleteInput;
